import Dutch from 'src/assets/icons/flags/nl-NL.svg?react'
import German from 'src/assets/icons/flags/de-DE.svg?react'
import French from 'src/assets/icons/flags/fr-FR.svg?react'
import Polish from 'src/assets/icons/flags/pl-PL.svg?react'
import Italian from 'src/assets/icons/flags/it-IT.svg?react'
import Spanish from 'src/assets/icons/flags/es-AR.svg?react'
import Turkish from 'src/assets/icons/flags/tr-TR.svg?react'
import EnglishGB from 'src/assets/icons/flags/en-GB.svg?react'
import EnglishUS from 'src/assets/icons/flags/en-US.svg?react'
import Portuguese from 'src/assets/icons/flags/pt-BR.svg?react'

export const locales = [
  {
    label: 'Português',
    key: 'pt-BR',
    icon: <Portuguese />,
  },
  {
    label: 'Deutsch',
    key: 'de-DE',
    icon: <German />,
  },
  {
    label: 'English',
    key: 'en-GB',
    icon: <EnglishGB />,
  },
  {
    label: 'English',
    key: 'en-US',
    icon: <EnglishUS />,
  },
  {
    label: 'Español',
    key: 'es-AR',
    icon: <Spanish />,
  },
  {
    label: 'Français',
    key: 'fr-FR',
    icon: <French />,
  },
  {
    label: 'Italiano',
    key: 'it-IT',
    icon: <Italian />,
  },
  {
    label: 'Nederlands',
    key: 'nl-NL',
    icon: <Dutch />,
  },
  {
    label: 'Polski',
    key: 'pl-PL',
    icon: <Polish />,
  },
  {
    label: 'Türkçe',
    key: 'tr-TR',
    icon: <Turkish />,
  },
]
